import { FETCH_TAG_LIST_QUERY } from "../../graphQL/queries/tagQueries";

export const fetchTagList = FETCH_TAG_LIST_QUERY;
